import { Text } from '@chakra-ui/react';
import React from 'react';

const InputNames = ({ children, ...props }) => {
    return (
        <Text fontWeight='500' fontSize='16px' lineHeight='24px' {...props}>
            {children}
        </Text>
    );
};

export default InputNames;
